import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {DomSanitizer} from '@angular/platform-browser';
import {LineObject} from '../DTOs/LineObject.component';
import {ObjectManager} from '../DTOs/ObjectManager.component';
import {HttpClient} from '@angular/common/http';

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var i18nVS: any;
declare var getLinesFromCity: any; // URL dinámica para que Funcione tanto en Liferay como en VSC
declare var nombreLineaClicada: any;
declare var colorLineaClicada: any;
declare var idLineaClicada: any;

@Component({
	selector: 'app-service-information-lineas',
	templateUrl: './lineas.component.html',
	styleUrls: ['../service-information.component.css']
})

export class LineasComponent implements OnInit {
	loadingLinesClass = '';
	i18nL = i18nVS;
	filtroLineas = ''; // Necesario para recoger el onChange event
	jsonData;

	lineas: LineObject[] = [];
	objectManager = new ObjectManager;

	@Output() onLineSelected: EventEmitter<any> = new EventEmitter<any>();
	@Output() onLinesLoad: EventEmitter<any> = new EventEmitter<any>();
	@Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();

	/*----------------------------------------------- Funciones ----------------------------------------------------*/
	getBackground(color) {
		return this._sanitizer.bypassSecurityTrustStyle('#' + color);
	}

	leerDatos(): Observable<any> {
		return this.httpClient.post<any>(getLinesFromCity, {});
	}

	public concatenarOrigenDestino(origen, destino) {
		if ((origen !== '' && origen !== null && typeof origen !== 'undefined') &&
			(destino !== '' && destino !== null && typeof destino !== 'undefined')) {
			return origen + ' - ' + destino;
		} else {
			if (origen !== '' && origen !== null && typeof origen !== 'undefined') {
				return origen;
			} else {
				if (destino !== '' && destino !== null && typeof destino !== 'undefined') {
					return destino;
				}
			}
		}
	}

	public setIdLinea(id) {
		const lineaClicada = this.lineas.filter(item => item.getId() === id);
		colorLineaClicada = '#' + lineaClicada[0].getColor(); // El color que se va a usar en muchos componentes
		nombreLineaClicada = lineaClicada[0].getName(); // Como el ID es único siempre nos llegara una única línea
		idLineaClicada = lineaClicada[0].getId(); // El nombre que sale dentro del círculo en la parte de arriba

		this.onLineSelected.emit(lineaClicada[0]);
	}

	public recogerLineas() { // Recoge las lineas de un JSON
		this.leerDatos().subscribe(
			(response: any) => this.comprobandoJson(response),
			(err) => this.errorEnElJson(err),
			() => this.filtrarLineas());
	}

	public comprobandoJson(res: any) {
		try {
			this.jsonData = res;
		} catch (error) {
			this.errorEnElJson(error);
		}
	}

	public errorEnElJson(error) {
		console.log('Error WS ' + error);
		this.onWebServiceError.emit(true);
	}

	public filtrarLineas() {
		try {
			this.lineas = this.objectManager.getLinesArrayFromJson(this.jsonData);

			this.onLinesLoad.emit(this.lineas);
			this.loadingLinesClass = 'invisible';

			// Filtro de líneas
			this.lineas = this.lineas.filter(item =>
				(item.getName() + ' ' + (item.getSurname() || '').toUpperCase())
					.search(this.filtroLineas.toUpperCase()) !== -1);
		} catch (error) {
			this.errorEnElJson(error);
		}
	}

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
		this.recogerLineas();
	}

	/*--------------------------------------------- Constructores ------------------------------------------------*/
	constructor(private httpClient: HttpClient, private _sanitizer: DomSanitizer) {
	}
}



// WEBPACK FOOTER //
// ./src/app/lineas/lineas.component.ts